/**
 * 产品常量：由 GET /products/tree（按当前用户权限裁剪）派生，见 ./product-tree.js。
 * - 导出的数组 / 对象引用固定不变，ProductTreeLoader 拿到数据后原地刷新内容；
 * - 加载完成前全部为空：ProductTreeLoader 在加载完成前不渲染页面，
 *   因此页面渲染期读取到的一定是已加载的数据；不要在模块顶层基于它们派生新数组。
 */

// { code, name, group, sub? }，group 为旧前端分组名（sticker / neku / jpsingle / unity / independent / 新分组码）
export const Apps = []

export const StickerApps = []
export const JPSingleApps = []
export const NekuApps = []
export const GameApps = []
export const UnityApps = []
export const IndependentApps = []

export const StickerMainApps = []
export const StickerSubApps = []

// [{ code, name }]：total + 可按分组聚合查询的分组（子组名前加 ⮑）
export const TotalsApp = []

export const TotalsJPApp = []

export const App0 = []
export const Apps1 = []

export const SubscribeApps = []

export const obtainAppNameByPid = (pid) => {
  return Apps.find((app) => app.code === pid.toString())?.name
}

// Baseline 模块使用的国家代码列表（country.baseline = true，按国家排序）
export const BaselineCountryCodes = []
